import styled from 'styled-components';
import {FlexRowSpaceBetween} from '@ui/style/styles';
import {Button} from '@ui/atoms/button';
import {getColorFromTheme} from '../../../../../../../../ui/ui-utils';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
`;
export const CancellationDialogShell = styled.form`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(30, 30, 47, 0.16);
  max-height: calc(100vh - 48px);
  overflow: hidden;
  width: min(520px, 100%);
`;

export const CancellationDialogHeader = styled.div`
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  padding: 18px 20px;
`;

export const CancellationDialogTitle = styled.h2`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 18px/26px Graphik, sans-serif;
  margin: 0;
`;

export const CancellationDialogBody = styled.div`
  max-height: calc(100vh - 190px);
  overflow-y: auto;
  padding: 20px;
`;

export const CancellationDialogDescription = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 14px/22px Graphik, sans-serif;
  margin: 0;
`;

export const CancellationDialogNotice = styled.div<{$warning?: boolean}>`
  background: ${({$warning}) =>
    $warning ? getColorFromTheme('orange100') : getColorFromTheme('purple100')};
  border: 1px solid
    ${({$warning}) =>
      $warning
        ? getColorFromTheme('orange200')
        : getColorFromTheme('purple200')};
  border-radius: 8px;
  color: ${getColorFromTheme('textBody')};
  font: 400 13px/20px Graphik, sans-serif;
  margin-top: 16px;
  padding: 12px;

  strong {
    color: ${getColorFromTheme('blackTwo')};
  }
`;

export const CancellationDialogFooter = styled.div`
  align-items: center;
  background: ${getColorFromTheme('backgroundLight')};
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 16px 20px;

  > button {
    min-height: 40px;
    padding: 8px 16px;
  }

  @media (max-width: 500px) {
    align-items: stretch;
    flex-direction: column;

    > button {
      width: 100%;
    }
  }
`;

export const DestructiveButton = styled(Button)`
  background: ${getColorFromTheme('red400')};
  border-color: ${getColorFromTheme('red400')};
  color: ${getColorFromTheme('alwaysWhite')};

  &:hover:not(:disabled) {
    filter: brightness(0.94);
  }
`;

export const SeatModalPositioner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100%;
  padding: 24px;
`;

export const SeatDialogShell = styled.form`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(30, 30, 47, 0.16);
  max-height: calc(100vh - 48px);
  overflow: hidden;
  width: min(520px, 100%);
`;

export const SeatDialogHeader = styled.div`
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  padding: 18px 20px;
`;

export const SeatDialogTitle = styled.h3`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 18px/26px Graphik, sans-serif;
  margin: 0;
`;

export const SeatDialogBody = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 16px 20px 20px;
`;

export const SeatDialogDescription = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 14px/22px Graphik, sans-serif;
  margin: 0 0 10px;
`;

export const SeatDialogNotice = styled.p`
  background: ${getColorFromTheme('backgroundLight')};
  border-radius: 8px;
  color: ${getColorFromTheme('textBody')};
  font: 400 12px/18px Graphik, sans-serif;
  margin: 0;
  padding: 10px 12px;
`;

export const SeatDialogField = styled.div`
  margin-top: 18px;
`;

export const SeatDialogCapacity = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 12px/18px Graphik, sans-serif;
  margin: 8px 0 0;
`;

export const SeatDialogFooter = styled.div`
  align-items: center;
  background: ${getColorFromTheme('backgroundLight')};
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 16px 20px;

  > button {
    min-height: 40px;
    padding: 8px 16px;
  }

  @media (max-width: 500px) {
    > button {
      flex: 1;
    }
  }
`;

export const InfoContainer = styled.div`
  background: ${getColorFromTheme('backgroundDark')};
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  color: ${getColorFromTheme('textBody')};
  font-size: 14px;
  text-align: center;
  justify-content: center;
  align-items: center;
`;
export const RetryPaymentNotificationDiv = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${getColorFromTheme('red400')};
  color: ${getColorFromTheme('alwaysWhite')};
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PlanDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
  min-width: 0;
  padding: 24px;

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
`;

export const SubscriptionCardTitle = styled.h2`
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  color: ${getColorFromTheme('blackTwo')};
  font: 600 16px/24px Graphik, sans-serif;
  margin: 0;
  padding: 0 0 16px;
`;

export const SubscriptionRow = styled.div`
  align-items: center;
  display: grid;
  gap: 32px;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 420px);
  padding: 24px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  }

  &:last-child {
    padding-bottom: 0;
  }

  @media (max-width: 800px) {
    align-items: stretch;
    gap: 16px;
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const SubscriptionCopy = styled.div`
  min-width: 0;
`;

export const SubscriptionLabel = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/20px Graphik, sans-serif;
`;

export const SubscriptionDescription = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 14px/20px Graphik, sans-serif;
  margin: 4px 0 0;
  max-width: 520px;
`;

export const SubscriptionControl = styled.div`
  min-width: 0;
`;

export const PlanOverview = styled.div`
  align-items: center;
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 10px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  min-height: 72px;
  padding: 14px 16px;
`;

export const StatusPill = styled.span<{
  $ending?: boolean;
  $warning?: boolean;
}>`
  background: ${({$ending, $warning}) =>
    $ending || $warning
      ? getColorFromTheme('orange100')
      : getColorFromTheme('green100')};
  border-radius: 999px;
  color: ${({$ending, $warning}) =>
    $ending || $warning
      ? getColorFromTheme('orange400')
      : getColorFromTheme('green400')};
  display: inline-flex;
  font: 600 12px/18px Graphik, sans-serif;
  margin-bottom: 5px;
  padding: 3px 8px;
`;

export const PlanName = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/20px Graphik, sans-serif;
`;

export const PlanPrice = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  flex: 0 0 auto;
  text-align: right;

  strong {
    display: block;
    font: 600 20px/28px Graphik, sans-serif;
  }

  span {
    color: ${getColorFromTheme('textBody')};
    display: block;
    font: 400 12px/18px Graphik, sans-serif;
  }
`;

export const PlanActions = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 12px;

  > button {
    min-height: 40px;
  }

  @media (max-width: 500px) {
    align-items: stretch;
    flex-direction: column;

    > button {
      width: 100%;
    }
  }
`;

export const SeatDetails = styled.div`
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;

  .seatMetric {
    padding: 16px;
  }

  .seatMetric + .seatMetric {
    border-left: 1px solid ${getColorFromTheme('borderLight')};
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;

    .seatMetric + .seatMetric {
      border-left: 0;
      border-top: 1px solid ${getColorFromTheme('borderLight')};
    }
  }
`;

export const PaymentDate = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/20px Graphik, sans-serif;
  padding: 14px 0;
  text-align: right;

  @media (max-width: 800px) {
    text-align: left;
  }
`;

export const CardDetailsDiv = styled(PlanDiv)``;

export const PaymentHistoryDiv = styled(PlanDiv)``;

export const PaymentMethodPanel = styled.div`
  align-items: center;
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 10px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  min-height: 64px;
  padding: 12px 14px;

  @media (max-width: 500px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const PaymentCardName = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/20px Graphik, sans-serif;
`;

export const PaymentCardMeta = styled.div`
  color: ${getColorFromTheme('textBody')};
  font: 400 12px/18px Graphik, sans-serif;
  margin-top: 4px;
`;

export const HistoryRow = styled.div`
  align-items: center;
  display: grid;
  gap: 32px;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 420px);
  padding: 20px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  }

  &:last-child {
    padding-bottom: 0;
  }

  @media (max-width: 800px) {
    align-items: stretch;
    gap: 16px;
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const HistoryMeta = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
`;

export const PaymentStatusPill = styled.span<{
  $tone?: 'success' | 'warning' | 'danger' | 'neutral';
}>`
  align-items: center;
  background: ${({$tone}) => {
    if ($tone === 'success') return getColorFromTheme('green100');
    if ($tone === 'warning') return getColorFromTheme('orange100');
    if ($tone === 'danger') return getColorFromTheme('red100');
    return getColorFromTheme('backgroundDark');
  }};
  border-radius: 8px;
  color: ${({$tone}) => {
    if ($tone === 'success') return getColorFromTheme('green400');
    if ($tone === 'warning') return getColorFromTheme('orange400');
    if ($tone === 'danger') return getColorFromTheme('red400');
    return getColorFromTheme('textBody');
  }};
  display: inline-flex;
  font: 600 12px/20px Graphik, sans-serif;
  padding: 4px 8px;
  text-transform: capitalize;
`;

export const BillingActivityDescription = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 13px/20px Graphik, sans-serif;
  margin: 12px 0 0;
`;

export const BillingSupportLink = styled.a`
  color: ${getColorFromTheme('purple300')};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const HistoryControl = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const HistoryAmount = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  text-align: right;

  span {
    color: ${getColorFromTheme('textBody')};
    display: block;
    font: 400 12px/18px Graphik, sans-serif;
  }

  strong {
    display: block;
    font: 600 14px/20px Graphik, sans-serif;
    margin-top: 2px;
  }
`;

export const ReceiptLink = styled.a`
  color: ${getColorFromTheme('purple300')};
  display: block;
  font: 500 12px/18px Graphik, sans-serif;
  margin-top: 4px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyBillingState = styled.div`
  color: ${getColorFromTheme('textBody')};
  font: 400 14px/20px Graphik, sans-serif;
  padding-top: 24px;
`;

export const ResponsiveFlexRowBetween = styled(FlexRowSpaceBetween)`
  .text {
    width: 60%;
  }
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    .text {
      width: 100%;
      margin-bottom: 10px;
    }
  }
`;
